<template>
  <div>
    <PageLoader v-bind:storage="appLoading" />
    <ServerError v-if="ServerError" />

    <v-snackbar v-model="showSnackBar" color="#FF1313" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center>
      <v-flex text-left xs12 lg10 px-2 pt-12 pt-md-4 >
        <span id="pageContent" v-html="pageContent"></span>
      </v-flex>
    </v-layout>
  <v-card  v-if="
        id == 'Sell on Styloop' ||
        id == 'Collaborate with us' ||
        id == 'Invest With US'
      " flat color="#F0F0F0" class="py-4">
      <v-layout
      wrap
      justify-center
      pa-2
     
    >
      <v-flex xs12>
        <span
          style="font-family: poppinsmedium; font-size: 18px; color: #000000"
        >
          For Enquiries
        </span>
      </v-flex>
      <v-flex xs12 sm11 lg10 xl8>
        <v-layout wrap justify-center>
          <v-flex xs12 sm4 lg4 px-2 text-left align-self-center>
            <span
              style="font-family: ; font-size: 14px; color: #ababab"
              class="pl-3"
            >
              Email
            </span>
            <v-text-field
              ref="email"
              color="#828282"
              placeholder="Email Id"
              type="email"
              outlined
              dense
              v-model="email"
              hide-details
            />
          </v-flex>
          <v-flex xs12 sm4 lg4 px-2 text-left align-self-center>
            <span
              style="font-family: ; font-size: 14px; color: #ababab"
              class="pl-3"
            >
              Phone
            </span>
            <v-text-field
              ref="phone"
              color="#828282"
              placeholder="Phone"
              type="number"
              outlined
              dense
              v-model="phone"
              hide-details
            />
          </v-flex>
          <v-flex xs12 sm4 lg4 px-2 text-left align-self-center>
            <span
              style="font-family: ; font-size: 14px; color: #ababab"
              class="pl-3"
            >
              &nbsp;
            </span>
            <v-btn
              block
              dark
              tile
              color="#FF1313"
              depressed
              class="text-capitalize"
              @click="validateInput"
              :ripple="false"
            >
              <span style="font-family: poppinssemibold; font-size: 14px">
                Submit
              </span>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-card>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["id"],
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      pageContent: null,
      email: null,
      phone: null,
    };
  },
  beforeMount() {
    this.getData();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/static/getbyname",
        params: {
          Name: this.id,
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.appLoading = false;
            this.pageContent = response.data.data.Value;
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    validateInput() {
      if (!this.email) {
        this.msg = "Please provide your email";
        this.showSnackBar = true;
        return;
      }
      if (!this.phone) {
        this.msg = "Please provide your phone number";
        this.showSnackBar = true;
        return;
      }
      this.sentQuery();
    },
    sentQuery() {
      var userData = {};
      userData["email"] = this.email;
      userData["phone"] = this.phone;
      userData["subject"] = this.id;
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/home/businessquery/add",
        data: userData,
      })
        .then((response) => {
          this.appLoading = false;
          this.email = null;
          this.phone = null;
          this.msg = response.data.msg;
          this.showSnackBar = true;
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>
<style >
#pageContent p img {
  max-width: 100%!important;
  max-height: 200vh!important;
}
/* img {
    width: 100%!important;
} */
</style>